/*
 * VTee モバイルヘッダー: スクロール検出
 * - スクロール量 > 24px で .section-header に is-scrolled クラス付与
 * - 透明 → 不透明 (PCと同じ) に切替えるための CSS フック
 */
(function () {
  'use strict';

  var THRESHOLD = 24;
  var header = null;

  function update() {
    if (!header) return;
    var scrolled = window.scrollY > THRESHOLD;
    header.classList.toggle('is-scrolled', scrolled);
  }

  function init() {
    header = document.querySelector('.section-header');
    if (!header) return;
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
